const skipLinkName = 'skip-link-content';

module.exports = { skipLinkName };
